import { clientApiCall, clientApiCallWithStatus } from "./apiCallWrapper";
import type { ClientApiResult } from "./apiCallWrapper";
import type {
  PersonalAuto,
  UpdateUserInfoPayload,
  UserData,
  UserMutationResponse,
} from "./types/user";

const withCredentials = { withCredentials: true };

/** Клиентский API личного кабинета Bitrix bxApi (/user/*). */
export default (_axios: any, config: any) => ({
  /**
   * Возвращает результат с признаком неудачи: пустой ответ приходит и гостю,
   * и при таймауте, а закешировать как «гость» можно только первое — иначе
   * залогиненный пользователь после одного таймаута на час видит себя
   * разлогиненным (см. redux/action-creaters/user).
   */
  getUser(): Promise<ClientApiResult<UserData>> {
    return clientApiCallWithStatus<UserData>(`${config.API_URL}/user/getUser`, {
      api: "user.getUser",
      skipForRobots: true,
      axiosConfig: withCredentials,
    });
  },

  updateInfo(
    payload: UpdateUserInfoPayload,
  ): Promise<UserMutationResponse | null> {
    return clientApiCall<UserMutationResponse>(
      `${config.API_URL}/user/updateInfo`,
      {
        api: "user.updateInfo",
        method: "post",
        params: {},
        axiosConfig: {
          ...withCredentials,
          params: {
            name: payload.name ?? "",
            lastName: payload.lastName ?? "",
          },
        },
      },
    );
  },

  updateAutos(
    autos: Array<string | number>,
  ): Promise<UserMutationResponse | null> {
    return clientApiCall<UserMutationResponse>(
      `${config.API_URL}/user/updateAutos`,
      {
        api: "user.updateAutos",
        method: "post",
        params: {},
        axiosConfig: {
          ...withCredentials,
          params: { autos: String(autos) },
        },
      },
    );
  },

  getPersonalAutos(): Promise<PersonalAuto[] | null> {
    return clientApiCall<PersonalAuto[]>(
      `${config.API_URL}/user/getPersonalAutos`,
      { api: "user.getPersonalAutos" },
    );
  },

  unsubscribe(params: Record<string, unknown>): Promise<string | null> {
    return clientApiCall<string>(`${config.API_URL}/user/unsubscribe`, {
      api: "user.unsubscribe",
      params,
    });
  },

  logOut(): Promise<unknown | null> {
    return clientApiCall(`${config.API_URL}/user/logOut`, {
      api: "user.logOut",
    });
  },
});
